const auth_status = {
    page_title: 'Kimlik doğrulama durumu',
    title: 'Kimlik doğrulama durumu',
    description: 'Kimlik doğrulama durumunu kontrol et.',
};
export default Object.freeze(auth_status);
